import { render, staticRenderFns } from "./Cultures.vue?vue&type=template&id=44ddb3f2&scoped=true&"
import script from "./Cultures.vue?vue&type=script&lang=js&"
export * from "./Cultures.vue?vue&type=script&lang=js&"
import style0 from "./Cultures.vue?vue&type=style&index=0&id=44ddb3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ddb3f2",
  null
  
)

export default component.exports